import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { ISlotData } from "../../../utils/interfaces";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";
import * as uuid from "uuid";

export async function PostSlot(slotInformation: ISlotData) {
  const uuidValue = uuid.v1();
  const data = auxiliarData.Slot(slotInformation, uuidValue);
  const url = `${endpoints.WORKFLOWFHIR}/Slot/${uuidValue}`;

  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .put(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Success &&
        response.status !== HTTPResponseStatus.Created
      ) {
        throw new Error(`PutSlot: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PostSlot ", error);
      // toast.error(`PostSlot Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
